import React from 'react';

export default function InlineCircleLoader({
	                                           size = 'big',//small|medium|big
	                                           showLoaderAnimation = true,
	                                           loadingPosition
                                           }) {
	return (
		<div className={`preloader-wrapper ${size} active`}>
			<div className='spinner-layer spinner-blue'>
				<div className='circle-clipper left'>
					<div className='circle' />
				</div>
				<div className='gap-patch'>
					<div className='circle' />
				</div>
				<div className='circle-clipper right'>
					<div className='circle' />
				</div>
			</div>

			<div className='spinner-layer spinner-red'>
				<div className='circle-clipper left'>
					<div className='circle' />
				</div>
				<div className='gap-patch'>
					<div className='circle' />
				</div>
				<div className='circle-clipper right'>
					<div className='circle' />
				</div>
			</div>

			<div className='spinner-layer spinner-yellow'>
				<div className='circle-clipper left'>
					<div className='circle' />
				</div>
				<div className='gap-patch'>
					<div className='circle' />
				</div>
				<div className='circle-clipper right'>
					<div className='circle' />
				</div>
			</div>

			<div className='spinner-layer spinner-green'>
				<div className='circle-clipper left'>
					<div className='circle' />
				</div>
				<div className='gap-patch'>
					<div className='circle' />
				</div>
				<div className='circle-clipper right'>
					<div className='circle' />
				</div>
			</div>
			{loadingPosition !== undefined &&
			<div className='progress'>
				<div className='determinate' style={{ width: `${loadingPosition * 100}%` }} />
			</div>
			}
		</div>
	);
}